import { Directive, ElementRef, Input, NgZone, OnChanges } from '@angular/core';

@Directive({
  selector: '[countUp]'
})
export class CountUpDirective implements OnChanges {
  @Input() startValue: number = 0
  @Input() countUp: number = 0
  @Input() duration: number = 800

  /**
  * Constructor
  *
  * @param {ElementRef} element
  * @param {NgZone} ngZone
  * 
  */
  constructor(
    private element: ElementRef,
    private ngZone: NgZone
  ) { }

  ngOnChanges() {
    this.ngZone.runOutsideAngular(() => { // Inicia la animación fuera de la zona de animación de Angular
      this.animate(this.startValue ?? 0, this.countUp ?? 0, this.duration)
    })
  }

  private animate(initialValue: number, maxValue: number, duration: number): void {
    const range = maxValue - initialValue // Obtiene el rango
    const start = performance.now() // Indica la marca de tiempo de inicio
    const isInteger = Number.isInteger(maxValue) // Indica si el número objetivo es entero o no

    const tick = (t: number) => { // Fn que se ejecuta en cada frame de la animación
      const progress = t - start // Obtiene cuanto tiempo ha pasado desde que empezó
      const ratio = Math.min(progress / duration, 1)  // Comprueba si ha terminado la animación

      const value = initialValue + ratio * range // Calcula el valor en cada frame

      const finalValue = isInteger
        ? Math.floor(value) // Si es entero mantiene en cada frame de la animación números enteros
        : Math.round(value * 100) / 100 // Si es decimal mantiene en cada frame de la animación números decimales

      this.element.nativeElement.innerText = this.transformValue(finalValue) // Inserta el valor en el DOM

      if (ratio < 1) requestAnimationFrame(tick) // Mientras la animación no ha terminado sigue
    }

    requestAnimationFrame(tick) // Inicia la animación
  }

  private transformValue(value: number): string { // Formatea el número en el formato español
    const num = Number(value)

    return new Intl.NumberFormat('es-ES').format(num)
  }
}
